import { FunctionComponent, useEffect } from 'react';
import * as vp from 'vopay';
import { Button } from 'vopay';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../../../providers/Layout.provider';
import { useToken } from '../../../providers/Token.provider';
import styles from '../../Messages/Messages.module.scss';
import BrandingLogo from '../../UI/BrandingLogo/BrandingLogo';

type DataProps = {
  paymentMethod: string;
  origin: string;
  pageCount: number;
};

type FC = FunctionComponent;
const { Box } = vp;
const ConnectionError: FC = () => {
  const { color, setLayoutInfo } = useLayout();
  const history = useHistory();
  const { state } = useLocation<DataProps>();
  const { token } = useToken();
  const { t } = useTranslation('translations', { keyPrefix: 'ConnectionError' });
  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'moon',
      '',
      80,
      20,
      0,
      false,
      false,
    );
  }, []);

  return (
    <div className={styles.welcomeContainer} style={{ maxWidth: '770px' }}>
      <div className={styles.welcomeMSGContainer}>
        <Box flx="col">
          <Box jc="center" pb="lg">
            {token?.BrandingDetails?.Logo && <BrandingLogo src={token?.BrandingDetails?.Logo} />}
          </Box>

          <div className={styles.title}>{`${t('title')}`}</div>
          <div className={styles.welcomeDescContainer}>
            <p>
              {`${t('message')}`} <br />
              {`${t('message2')}`}
            </p>
            <p> {`${t('persists')}`}</p>
          </div>
        </Box>
      </div>
      <div className={styles.btnsContainer}>
        <Button
          id="try-again-btn"
          label="Try Again"
          width="100%"
          background={color}
          textColor={vp.getContrastColor(color)}
          textSize={1}
          size="xlg"
          round
          noShadow
          bold
          onClick={() =>
            history.push({
              pathname: `/connect/processor/${state?.paymentMethod}`,
              state: {
                paymentMethod: state?.paymentMethod,
                origin: state?.origin,
                isRedirect: true,
                pageCount: state?.pageCount,
              },
            })
          }
        />
      </div>
    </div>
  );
};

export default ConnectionError;
